import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import { linkPropertiesShape } from '../../propTypes';
import { getEditionArticles, getSliceClickthrough } from '../../selectors';
import Article, { articlePropTypes } from './Article';
import { tileStyle } from '../../styles/tiles';
import makeItemLink from '../../helpers/makeItemLink';

const ArticlesFragment = ({
  articleClassName, classes, clickthrough, articles,
}) => (
  <>
    {articles.map((article, i) => (
      <Article
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        className={cn(classes.article, articleClassName)}
        {...article}
        link={article.slug ? makeItemLink(article, clickthrough, 'slug') : undefined}
      />
    ))}
  </>
);

ArticlesFragment.propTypes = {
  articleClassName: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape(articlePropTypes)).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  clickthrough: PropTypes.shape(linkPropertiesShape).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
};

ArticlesFragment.defaultProps = {
  articleClassName: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  articles: getEditionArticles(state, sliceId),
  clickthrough: getSliceClickthrough(state, sliceId),
});

export default compose(
  connect(mapStateToProps),

  injectSheet({
    article: tileStyle(3),
  }),
)(ArticlesFragment);
